//Responsive AI2html
import throttle from 'lodash.throttle';
import { findElementByIdInShadowDom, findElementInShadowDom } from './render';

const RESIZER_CLASS_NAME = 'g-resizer-v3-init';

/**
 * @param {HTMLElement} container
 */
const getElementWidths = (container) => {
  const elements = Array.from(
    container?.querySelectorAll('.g-artboard[data-min-width]') ?? []
  );

  return elements.reduce((widths, el) => {
    const id = `${el.getAttribute('id')}`;
    const minWidth = parseInt(el.getAttribute('data-min-width') || '0');
    const maxWidth = parseInt(el.getAttribute('data-max-width') || '99999');

    // @ts-ignore
    widths[id] = {
      minWidth,
      maxWidth,
    };

    return widths;
  }, {});
};

/**
 * @param {HTMLElement} container
 * @param {Record<string, Record<string, number>>} elementsMap
 */
const resize = (container, elementsMap) => {
  const parent = container.parentNode;
  if (!parent) return;

  // @ts-ignore
  const parentWidth = parent.getBoundingClientRect().width;

  Object.entries(elementsMap).forEach(([elId, mapping]) => {
    const el = findElementByIdInShadowDom(elId);
    if (!el) return;
    el.style.display = 'none';

    if (parentWidth >= mapping.minWidth && parentWidth <= mapping.maxWidth) {
      el.style.display = 'block';
    }
  });
};

/**
 * @param {HTMLElement} container
 * @param {Record<string, Record<string, number>>} elementsMap
 */
const resizeEventHandler = (container, elementsMap) => {
  return () => {
    resize(container, elementsMap);

    // Below snippet is for support in Android and iOS
    try {
      if (window.require) {
        // @ts-ignore
        window.require(['foundation/main'], () => {
          // @ts-ignore
          window.require(
            ['shared/interactive/instances/app-communicator'],
            (AppCommunicator) => {
              AppCommunicator.triggerResize();
            }
          );
        });
      }
    } catch (e) {
      console.log(e);
    }
  };
};

/**
 * @param {string} elementSelector
 */
export const ai2htmlResize = (elementSelector) => {
  if (!elementSelector) {
    console.error('No element selector provided');
  }

  const container = findElementInShadowDom(elementSelector);
  if (!container) {
    console.error(
      `Unable to find container element with selector: ${elementSelector}`
    );
    return;
  }

  if (container.className.indexOf(RESIZER_CLASS_NAME) > -1) {
    console.error(
      `Resizer already found for element ${elementSelector}, exiting`
    );
    return;
  }

  container.className += ` ${RESIZER_CLASS_NAME}`;

  const elementsMap = getElementWidths(container);
  const handler = resizeEventHandler(container, elementsMap);

  // Resize immediately
  document.addEventListener('DOMContentLoaded', handler);

  // Trigger resizer when viewport changes
  window.addEventListener('resize', throttle(handler, 200));
};
